export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"apple-mobile-web-app-title","content":"Cene na pijacama - stoka, voće, povrće, žitarice"},{"name":"author","content":"Esenca software"},{"name":"description","content":"Cena voća, povrća, stoke, žitarica na pijacama u Srbiji. Kalendar okota životinja, zelenih i stočnih pijaca, zaštita od bolesti i štetočina."},{"property":"og:description","content":"Cena voća, povrća, stoke, žitarica na pijacama u Srbiji. Kalendar okota životinja, zelenih i stočnih pijaca, zaštita od bolesti i štetočina."},{"property":"og:title","content":"Cene na pijacama - stoka, voće, povrće, žitarice"},{"property":"og:image","content":"https://pijace.com/1200x630.png"},{"property":"og:site_name","content":"Pijace.com"},{"property":"og:type","content":"website"},{"property":"og:locale","content":"sr_RS"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Cene na pijacama - stoka, voće, povrće, žitarice"},{"name":"twitter:description","content":"Cena voća, povrća, stoke, žitarica na pijacama u Srbiji. Kalendar okota životinja, zelenih i stočnih pijaca, zaštita od bolesti i štetočina."},{"name":"twitter:image","content":"https://pijace.com/1200x630.png"},{"name":"theme-color","content":"#FFFFFF"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"google-site-verification","content":"JZaXwLdcayjSweck-2iW-bXLrUW1J981Z7W_U2mHvrY"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.png"},{"rel":"apple-touch-icon","href":"/icon-256x256.png"},{"rel":"preload","as":"font","type":"font/woff2","href":"/fonts/pijaceicon.woff2","crossorigin":"anonymous"}],"style":[],"script":[{"src":"https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js","async":true,"data-ad-client":"ca-pub-9600750642603999"}],"noscript":[],"htmlAttrs":{"dir":"ltr","lang":"sr-RS"},"title":"Cene na pijacama - stoka, voće, povrće, žitarice"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true